<template>
  <ChartNormal
    size="12"
    offset="0"
    title="Tested"
    chart="column"
    chartType="tested"
    :isCity="false"
    :withDate="true"
    :withFinancial="false"
    :tested="true"
  />
</template>

<script>
import ChartNormal from "../../../components/chart/chartNormal";

export default {
  name: "Tested",
  components: {
    ChartNormal
  }
};
</script>
